import { QuoteBlockLayout } from '@modules/VanOord.CMS/Frontend/cmsPage/blocks/block/quoteBlock/quoteBlock.layout'
import { StyleguideExample, StyleguidePart } from '@shared/Hoppinger.Styleguide/Frontend'
import * as React from 'react'
import { dummyData } from '../../../config/dummyData'

// ---------- ---------- ---------- ---------- ---------- ----------
// ---------- ---------- ---------- ---------- ---------- ----------
// ---------- ----------  STYLEGUIDE RENDERER  ---------- ----------
// ---------- ---------- ---------- ---------- ---------- ----------
// ---------- ---------- ---------- ---------- ---------- ----------

export const ComponentsQuoteBlock = () => (
  <>
    <StyleguidePart title="Without Image" intro="">
      <StyleguideExample showExampleLabel={false} isFullScreen={false}>
        <ComponentQuoteBlock />
      </StyleguideExample>
    </StyleguidePart>

    <StyleguidePart title="With Image" intro="">
      <StyleguideExample showExampleLabel={false} isFullScreen={false}>
        <ComponentQuoteBlock showImage />
      </StyleguideExample>
    </StyleguidePart>
  </>
)

// ---------- ---------- ---------- ---------- ---------- ----------
// ---------- ---------- ---------- ---------- ---------- ----------
// ---------- ----------        SNIPPETS       ---------- ----------
// ---------- ---------- ---------- ---------- ---------- ----------
// ---------- ---------- ---------- ---------- ---------- ----------

export const ComponentQuoteBlock = (props: { showImage?: boolean }) => (
  <QuoteBlockLayout
    id="example-quote-block"
    text={dummyData.quote}
    author={dummyData.person}
    image={props.showImage ? dummyData.image : undefined}
    primaryUpdater={dummyData.primaryUpdater}
    secondaryUpdater={dummyData.secondaryUpdater}
    showUpdaterAsLink={false}
  />
)
